import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent} from './app.component';
import { SchooladdComponent } from './schooladd/schooladd.component';
import { SchooloverviewComponent } from './schooloverview/schooloverview.component';
import { SetupYourSchoolComponent } from './setupyourschool/setupyourschool.component';
import { AuthGuard } from '../../../../src/app/auth/auth.guard';

const routes: Routes = [
  { path: 'projectmanagement/:project_id',
    children: [
      { path: 'addschool', component: SchooladdComponent, canActivate: [AuthGuard]},
    ]
  },
  {
    path: 'schoolmanagement',
    children: [
      { path: '',  component: SchooloverviewComponent, canActivate: [AuthGuard]},
      { path: 'setup', component: SetupYourSchoolComponent, canActivate: [AuthGuard]}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
